/*
    © 2021 EcomGraduates.com. All rights reserved.
    https://www.ecomgraduates.com
*/

// Init Recently Viewed
const initRecentlyViewed = () => {
    const $el = document.querySelector('[data-recently-viewed]')

    if ($el) {
        let recentlyViewed = JSON.parse(localStorage.getItem('eg_bigstore_recently_viewed')) || []
        const isViewedBefore = recentlyViewed.some((product) => product.id === $el.dataset.productId)

        if (isViewedBefore) {
            recentlyViewed = recentlyViewed.filter((product) => product.id !== $el.dataset.productId)
        }

        if (recentlyViewed.length >= 50) {
            recentlyViewed.shift()
        }

        recentlyViewed.push({
            id: $el.dataset.productId,
            title: $el.dataset.productTitle,
            url: $el.dataset.productUrl,
            compare_at_price: $el.dataset.productCompareAtPrice,
            price: $el.dataset.productPrice,
            price_varies: $el.dataset.productPriceVaries,
            img_src: $el.dataset.productImgSrc,
            img_alt: $el.dataset.productImgAlt,
            viewed_at: Date.now()
        })

        localStorage.setItem('eg_bigstore_recently_viewed', JSON.stringify(recentlyViewed))
    }
}
initRecentlyViewed()

// Load products inside section
const initRecentlyViewedSection = () => {
    const section = document.querySelector('.recently-viewed')
    const recentlyViewed = JSON.parse(localStorage.getItem('eg_bigstore_recently_viewed')) || []

    if (!section) {
        return
    }

    dayjs.extend(window.dayjs_plugin_relativeTime)

    if (recentlyViewed.length > 0) {
        let html = ''
        recentlyViewed.reverse().forEach((product) => {
            html += `
                <li class="product-list-item splide__slide text-center overflow-hidden px-3 py-3 mb-4 animate__animated animate__faster opacity-0">
                <div class="card border-0 shadow-sm overflow-hidden">
                    <a 
                        class="img-wrapper d-block position-relative hover-effect-shine" 
                        href="${product.url}">
                        <img 
                            class="product-img img-fluid"
                            src="${window.resizeImage(product.img_src || 'no-image.gif', `${section.dataset.imgWidth}x${section.dataset.imgHeight}`, 'center')}"
                            alt="${product.img_alt}" 
                            width="${section.dataset.imgWidth}"
                            height="${section.dataset.imgHeight}"
                            loading="lazy">
                    </a>
                    <div class="card-body">
                        <h3 class="product-title title mb-2 h6">
                            <a 
                                class="text-decoration-none d-block text-ellipsis"  
                                href="${product.url}">
                                ${product.title}
                            </a>
                        </h3>
                        <p class="product-price text-price mb-3">
                            <s class="product-price-compare text-muted me-1 ${product.compare_at_price > product.price ? '' : 'd-none'}">
                                <span class="visually-hidden">
                                    Old price
                                </span>
                                ${window.formatMoney(product.compare_at_price)}
                            </s>
                            <span class="product-price-final">
                                <span class="price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                </span>
                                ${window.formatMoney(product.price)}
                            </span>
                        </p>
                        <p class="product-viewed-time small text-muted mb-2 text-muted">
                            ${dayjs().to(dayjs(product.viewed_at))}
                        </p>
                    </div>
                </li>
            `
            section.style.display = 'block'
            section.querySelector('.product-list').innerHTML = html

            const event = new Event('initFeaturedProductsSliders()')
            document.dispatchEvent(event)
        })
    } else {
        section.style.display = 'none'
    }
}
initRecentlyViewedSection()

// Clear list button
const initClearListBtn = () => {
    const $btn = document.querySelector('#offcanvas-recently-viewed-btn-clear')

    $btn?.addEventListener('click', () => {
        localStorage.removeItem('eg_bigstore_recently_viewed')

        initRecentlyViewedSection()

        setTimeout(() => {
            const bsOffcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-recently-viewed'))
            bsOffcanvas?.hide()
        }, 500)
    })
}
initClearListBtn()
